import { ColorEnum } from '@/constants/color'
import {
    selectedBorderColor,
    selectedContainerColor,
} from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/constants'
import { useAnimatedContainerStyle } from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/hooks/useAnimatedContainerStyle'
import Name from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/parts/Name'
import Price from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/parts/Price'
import { Color } from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/types'
import Animated from '@/features/ui/animated'
import { FC, ReactNode, memo } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface OptionItemProps {
    id: string
    selected: boolean
    disabled?: boolean
    name: string
    price?: string
    color?: Color
    onPress: (id: string) => void
    TailComponent?: ReactNode
}

const OptionItem: FC<OptionItemProps> = ({
    id,
    selected,
    disabled,
    name,
    price,
    color = 'primary',
    onPress,
    TailComponent,
}) => {
    const animatedStyle = useAnimatedContainerStyle(selected, {
        backgroundColor: selectedContainerColor[color],
        borderColor: selectedBorderColor[color],
    })

    const { styles } = useStyles(stylesheet, { disabled })

    const handlePress = () => onPress(id)

    return (
        <Animated.Pressable
            disabled={disabled}
            onPress={handlePress}
            style={[styles.container, !disabled && animatedStyle]}
        >
            <View style={styles.innerContainer}>
                <Name selected={selected} disabled={disabled} color={color}>
                    {name}
                </Name>
                {price && (
                    <Price selected={selected} disabled={disabled} color={color}>
                        {price}
                    </Price>
                )}
            </View>
            {TailComponent}
        </Animated.Pressable>
    )
}

const stylesheet = createStyleSheet({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 8,
        height: 60,
        width: '100%',
        paddingHorizontal: 8,
        variants: {
            disabled: {
                true: {
                    backgroundColor: ColorEnum.GRAY_400,
                },
            },
        },
    },
    innerContainer: {
        flex: 1,
        paddingHorizontal: 4,
        gap: 8,
    },
})

export default memo(OptionItem)
